// import React from "react"
// export default () => {
//   return null
// }

import React from "react"
import { Link } from "gatsby"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Player3D from "../../components/Player3D"

import { get3dFrameUrl } from "../../utils"
import {
  threePath,
  threeFrameCount,
  threeFrameWidth,
  threeDegrees,
  threeFrameHeight,
} from "../../constants"

const frames3d = []
for (let i = 1; i <= threeFrameCount; i++) {
  const frames = []
  for (let o = 0; o < threeDegrees; o++) {
    frames.push(get3dFrameUrl(threePath, i, o))
  }
  frames3d.push(frames)
}

const Interactive3DPage = () => {
  return (
    <Layout>
      <SEO
        title="Rotate interactive"
        description="An interactive web-app that allows you to see an animated 3d galloping horse from all angles."
        bodyClass="greenBackground"
      />
      <div style={{ padding: "10px 0" }}>
        <Link to="/" style={{ color: "black" }}>
          back
        </Link>
      </div>
      <Player3D
        fps={15}
        frames3d={frames3d}
        frameWidth={threeFrameWidth}
        frameHeight={threeFrameHeight}
      />
    </Layout>
  )
}

export default Interactive3DPage
